import { guardChildNodeByType } from './parsers/util.guard-element-type.js';

function parseXML(html, mimeType = "text/xml") {
  var _a;
  const domParser = new DOMParser();
  const doc = domParser.parseFromString(html, mimeType);
  const htmlNode = ((_a = doc.children[0]) == null ? void 0 : _a.tagName.toLowerCase()) === "html" ? doc.children[0] : void 0;
  const bodyNode = Array.from((htmlNode == null ? void 0 : htmlNode.childNodes) ?? []).find(
    guardChildNodeByType("body")
  );
  const pageNode = Array.from((bodyNode ?? doc).childNodes).find(
    guardChildNodeByType("Page")
  );
  return pageNode ?? bodyNode ?? doc;
}

export { parseXML };
//# sourceMappingURL=util.parse-xml.js.map
